(() => {
  const dialog = /** @type {HTMLDialogElement} */ (document.getElementById('video-guides-dialog'));
  const iframe = /** @type {HTMLIFrameElement} */ (document.getElementById('video-guides-iframe'));

  if (!dialog || !iframe) return;

  const closeBtn = dialog.querySelector('.video-guides__dialog-close');

  /** @param {string} youtubeId */
  function openVideo(youtubeId) {
    iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0`;
    dialog.showModal();
  }

  function closeVideo() {
    iframe.src = '';
    dialog.close();
  }

  // Play buttons — event delegation so it works after AJAX content swaps
  document.addEventListener('click', (e) => {
    const btn = /** @type {Element} */ (e.target).closest('.video-guides__play-btn');
    if (!btn) return;
    const youtubeId = btn.getAttribute('data-youtube-id');
    if (youtubeId) openVideo(youtubeId);
  });

  if (closeBtn instanceof HTMLButtonElement) {
    closeBtn.addEventListener('click', closeVideo);
  }

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeVideo();
  });

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    closeVideo();
  });
})();

(() => {
  const section = /** @type {HTMLElement} */ (document.querySelector('.video-guides[data-section-id]'));
  const form = /** @type {HTMLFormElement} */ (document.querySelector('.video-guides__search-form'));
  const searchInput = /** @type {HTMLInputElement} */ (document.getElementById('vg-search'));
  const filterSelect = /** @type {HTMLSelectElement} */ (document.getElementById('vg-filter'));
  const resultsEl = /** @type {HTMLElement} */ (document.getElementById('video-guides-results'));

  if (!section || !form || !searchInput || !filterSelect || !resultsEl) return;

  const sectionId = section.dataset.sectionId ?? '';
  const baseUrl = window.location.href.split('?')[0] ?? window.location.pathname;
  let currentController = /** @type {AbortController | null} */ (null);

  /** Builds the Shopify search URL for the current form state, or null to show the default collection */
  function buildSearchUrl() {
    const query = searchInput.value.trim();
    const productType = filterSelect.value;

    if (!query && !productType) return null;

    let q = query;
    if (productType) {
      q += (q ? ' ' : '') + `product_type:"${productType}" AND tag:video-guide`;
    } else {
      q += (q ? ' ' : '') + 'tag:video-guide';
    }

    return `/search?${new URLSearchParams({ q, type: 'product' }).toString()}`;
  }

  /** @param {string} url */
  async function fetchSection(url) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    section.classList.add('video-guides--loading');

    try {
      const sep = url.includes('?') ? '&' : '?';
      const response = await fetch(`${url}${sep}sections=${encodeURIComponent(sectionId)}`, {
        signal: currentController.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const data = await response.json();
      const html = data[sectionId];
      if (!html) throw new Error('Section not in response');

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newResults = doc.getElementById('video-guides-results');
      if (newResults) resultsEl.innerHTML = newResults.innerHTML;
    } catch (err) {
      if (/** @type {Error} */ (err).name !== 'AbortError') {
        console.error('[video-guides]', err);
      }
    } finally {
      section.classList.remove('video-guides--loading');
    }
  }

  // Intercept pagination link clicks inside the results area
  resultsEl.addEventListener('click', (e) => {
    const link = /** @type {Element} */ (e.target).closest('a.pagination__link');
    if (!link) return;
    const href = /** @type {HTMLAnchorElement} */ (link).href;
    if (!href) return;
    e.preventDefault();
    fetchSection(href);
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    fetchSection(buildSearchUrl() ?? baseUrl);
  });

  filterSelect.addEventListener('change', () => {
    fetchSection(buildSearchUrl() ?? baseUrl);
  });
})();
